import { useNewsItem } from 'app/frontend/base/config/queries'
import NewsItem from './NewsItem'
import { useParams } from 'react-router-dom'
import { useTeam } from 'app/frontend/base/config/context/team'

const NewsView = () => {
  const { id } = useParams()
  const { team } = useTeam()
  const { data: newsItem, isPending } = useNewsItem(
    team.id,
    id ? parseInt(id) : undefined,
  )

  if (isPending || !newsItem) return null

  return <NewsItem item={newsItem} />
}

export default NewsView
